<ul>
    <li>
        <a (click)="setFilterValue('type', 'all')" [class.active]="!filters?.type || (filters?.type === 'all')"><ng-container i18n>All</ng-container></a>
    </li>
    <li>
        <a (click)="setFilterValue('type', 'lite')" [class.active]="filters?.type === 'lite'"><ng-container i18n>Lite</ng-container></a>
    </li>
    <li>
        <a (click)="setFilterValue('type', 'paid')" [class.active]="filters?.type === 'paid'"><ng-container i18n>Paid</ng-container></a>
    </li>
    <li>
        <a (click)="setFilterValue('type', 'paid-over-quota')" [class.active]="filters?.type === 'paid-over-quota'"><ng-container i18n>Paid (over quota)</ng-container></a>
    </li>
    <li>
        <a (click)="setFilterValue('type', 'paid-almost-quota')" [class.active]="filters?.type === 'paid-almost-quota'"><ng-container i18n>Paid (almost quota)</ng-container></a>
    </li>
    <li>
        <a (click)="setFilterValue('type', 'stripe')" [class.active]="filters?.type === 'stripe'"><ng-container i18n>Stripe</ng-container></a>
    </li>
    <li>
        <a (click)="setFilterValue('type', 'stripe-off')" [class.active]="filters?.type === 'stripe-off'"><ng-container i18n>Stripe-off</ng-container></a>
    </li>
    <li>
        <hr />
    </li>
    <li>
        <a (click)="setFilterValue('type', 'ai-insights-users')" [class.active]="filters?.type === 'ai-insights-users'"><ng-container i18n>Users of AI Insights</ng-container></a>
    </li>
</ul>
